import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from '@/lib/auth';
import { Toaster } from '@/components/ui/sonner';
import Home from '@/pages/Home';
import Login from '@/pages/Login';
import Register from '@/pages/Register';
import Search from '@/pages/Search';
import ProjectDetail from '@/pages/ProjectDetail';
import BrokerDashboard from '@/pages/BrokerDashboard';
import BrokerKYC from '@/pages/BrokerKYC';
import BrokerProjects from '@/pages/BrokerProjects';
import BrokerLeads from '@/pages/BrokerLeads';
import BrokerLandingPages from '@/pages/BrokerLandingPages';
import AdminDashboard from '@/pages/AdminDashboard';
import LandingPageView from '@/pages/LandingPageView';
import BecomeBroker from '@/pages/BecomeBroker';
import Cities from '@/pages/Cities';
import BrokerProfile from '@/pages/BrokerProfile';

function ProtectedRoute({ children, roles }) {
  const { user, token, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center">Loading...</div>;
  if (!token || !user) return <Navigate to="/login" />;
  if (roles && !roles.includes(user.role)) return <Navigate to="/" />;
  return children;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          {/* Public */}
          <Route path="/" element={<Home />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/search" element={<Search />} />
          <Route path="/project/:id" element={<ProjectDetail />} />
          <Route path="/cities" element={<Cities />} />
          <Route path="/become-broker" element={<BecomeBroker />} />
          <Route path="/broker/:slug" element={<BrokerProfile />} />
          <Route path="/p/:brokerSlug/:projectSlug" element={<LandingPageView />} />

          {/* Broker */}
          <Route path="/broker" element={<ProtectedRoute roles={['broker']}><BrokerDashboard /></ProtectedRoute>} />
          <Route path="/broker/kyc" element={<ProtectedRoute roles={['broker']}><BrokerKYC /></ProtectedRoute>} />
          <Route path="/broker/projects" element={<ProtectedRoute roles={['broker']}><BrokerProjects /></ProtectedRoute>} />
          <Route path="/broker/leads" element={<ProtectedRoute roles={['broker']}><BrokerLeads /></ProtectedRoute>} />
          <Route path="/broker/landing-pages" element={<ProtectedRoute roles={['broker']}><BrokerLandingPages /></ProtectedRoute>} />

          {/* Admin */}
          <Route path="/admin" element={<ProtectedRoute roles={['admin', 'super_admin']}><AdminDashboard /></ProtectedRoute>} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </AuthProvider>
  );
}

export default App;
